import { Component, OnInit, TemplateRef, ViewChild, Input, ElementRef } from '@angular/core';
import { AppService } from '../../../app.service';
import { Intervention } from '../../../models/intervention';
import { Rucher } from '../../../models/rucher';
import { Ruche } from '../../../models/ruche';
import { AdminService } from '../../../admin/admin.service';
import { Action } from '../../../models/action';
import { InterRuche } from '../../../models/interRuche';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { padNumber } from '@ng-bootstrap/ng-bootstrap/util/util';
import { DateJson } from '../../../outils/dateJson';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Nomenclature } from '../../../models/nomenclature';

@Component({
  selector: 'write-intervention-modal',
  templateUrl: './write-intervention-modal.component.html',
  styleUrls: ['./write-intervention-modal.component.css'],
  providers: [ AdminService ]
})
export class WriteInterventionModalComponent implements OnInit {
  @ViewChild('content') modal: TemplateRef<any>;
  private intervention: Intervention;
  private rucher: Rucher;
  private interRuche: string = '-1';
  private typeActCourante: Nomenclature = new Nomenclature();
  private comActCourante: string;
  private typeActAFaireCourante: Nomenclature = new Nomenclature();
  private comActAFaireCourante: string;
  private interRucheCourante: InterRuche;
  private ruchesRenseignees: Ruche[] = [];
  private model;
  private isInterditBtn: boolean = true;
  private errors: string[] = [];
  private kilos;
  private grammes;
  private forceCourante = '-1';
  private dateDatePicker: NgbDateStruct;
  private type_ok: boolean;
  private meteo_ok: boolean;
  private temperature_ok: boolean;
  private kilos_ok: boolean;
  private grammes_ok: boolean;
  private libellesNom: String[];
  private isSectedItemAction: boolean = false;

  constructor(private appService:AppService, private adminService: AdminService) {
   }

   search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term.length < 1 ? []
       : this.appService.getNomenclaturesByType('TYPE_ACT').filter(v => v.libelle.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
   )
  
   formatter = (x: { libelle: string }) => x.libelle;
   
  ngOnInit() {
    this.appService.writeIntervetionModal = this.modal;
  }

  initIntervention(newInter: Intervention) {

    this.libellesNom = this.appService.getLibelleNomenclaturesByType('TYPE_ACT');
    
    this.intervention = newInter;
    this.rucher = this.appService.getRucher(newInter.id_rucher);
    
    if (this.intervention.id_inter_rucher !== '-1') {
      this.intervention.date_inter = new DateJson(new Date(this.intervention.date_inter.annee, this.intervention.date_inter.mois, this.intervention.date_inter.jour));
      if (this.intervention.date_inter.mois === 0) {
        this.intervention.date_inter.mois = 12;
        this.intervention.date_inter.annee--;
      }
      this.dateDatePicker = {year: this.intervention.date_inter.annee, month: this.intervention.date_inter.mois, day: this.intervention.date_inter.jour};
      this.ruchesRenseignees = [];
      this.intervention.interRuches.forEach(interRuche => {
        this.ruchesRenseignees.push(interRuche.ruche);
      });
      this.isInterditBtn = false;
    } else {
      this.reInitAct();
      this.reInitActAFaire();
      this.reInitInterRuche();
      this.ruchesRenseignees = [];
      this.dateDatePicker = null;
      this.isInterditBtn = true;
    }
    this.type_ok = true;
    this.meteo_ok = true;
    this.temperature_ok = true;
    this.kilos_ok = true;
    this.grammes_ok = true;
  }

  selectRuche() {
    if (this.interRuche === '-1') {
      this.interRucheCourante = null;
    } else {
      this.interRucheCourante = new InterRuche();
      this.interRucheCourante.ruche = this.appService.getRuche(this.interRuche);
      
      if (!this.interRucheCourante.ruche.varroas) {
        this.interRucheCourante.ruche.varroas = '-1';
      }
      if (!this.interRucheCourante.ruche.force_ruche) {
        this.interRucheCourante.ruche.force_ruche = '-1';
      }
    }
    this.verify();
  }

  addAction() {
    let newAction = new Action();
    newAction.type_action = this.typeActCourante.id_nom;
    newAction.commentaires = this.comActCourante;
    console.log(this.typeActCourante);
    this.interRucheCourante.actions.push(newAction);
    this.reInitAct();
  }

  removeAction(id_action: string) {
    this.interRucheCourante.actions.splice(this.interRucheCourante.actions.findIndex(action=>action.id_action===id_action), 1);
  }

  addActionAFaire() {
    let newAction = new Action();
    newAction.type_action = this.typeActAFaireCourante.id_nom;
    newAction.commentaires = this.comActAFaireCourante;
    this.interRucheCourante.actions_a_faire.push(newAction);
    this.reInitActAFaire();
  }

  removeActionAFaire(id_action: string) {
    this.interRucheCourante.actions_a_faire.splice(this.interRucheCourante.actions_a_faire.findIndex(action=>action.id_action===id_action), 1);
  }

  addRuche() {
    if (this.appService.getNomenclatureById(this.interRucheCourante.ruche.force_ruche).code === 'DCD') {
      this.interRucheCourante.ruche.active = this.appService.getNomenclatureByTypeAndCode('OUINON', 'N').id_nom;
    } else {
      if (this.interRucheCourante.ruche.force_ruche !== '-1')
      this.interRucheCourante.ruche.active = this.appService.getNomenclatureByTypeAndCode('OUINON', 'O').id_nom;
    }

    if (this.interRucheCourante.ruche.varroas === '-1') {
      this.interRucheCourante.ruche.varroas = null;
    }
    if (this.interRucheCourante.ruche.force_ruche === '-1') {
      this.interRucheCourante.ruche.force_ruche = null;
    }

    this.intervention.interRuches.push(this.interRucheCourante);
    this.ruchesRenseignees.push(this.interRucheCourante.ruche);
    this.reInitAct();
    this.reInitActAFaire();
    this.reInitInterRuche();
    this.interRucheCourante = new InterRuche();
  }

  removeRuche(id_ruche: string) {
    this.intervention.interRuches.splice(this.intervention.interRuches.findIndex(ruche=>ruche.ruche.id_ruche===id_ruche), 1);
    this.ruchesRenseignees.splice(this.ruchesRenseignees.findIndex(ruche=>ruche.id_ruche===id_ruche), 1);
    this.verify();
  }

  dateChange(dateChoosen: NgbDateStruct) {
    this.intervention.date_inter = new DateJson(dateChoosen);
    let eltDp = document.getElementById("dp");
    eltDp.classList.remove("is-invalid");
    this.verify();
  }

  selectType() {
    if (this.intervention.type !== '-1') {
      this.type_ok = true;
    }
  }

  selectMeteo() {
    if (this.intervention.meteo !== '-1') {
      this.meteo_ok = true;
    }
  }

  onSubmit(): boolean {
    if (this.testForm()) {
      if (this.intervention.id_inter_rucher === '-1') {
        this.appService.addIntervention(this.intervention).subscribe(interventions => {
          interventions.forEach(inter => {
            inter.date_inter = new DateJson(new Date(inter.date_inter.annee, inter.date_inter.mois, inter.date_inter.jour));
            if (inter.date_inter.mois === 0) {
              inter.date_inter.mois = 12;
              inter.date_inter.annee--;
            }
          });
          this.appService.listeInterventions=interventions;},
          (err: Response) => {
            console.log("Error occured");
        });
      } else {
        if (this.intervention.temperature && this.intervention.temperature.trim() === '') {
          this.intervention.temperature = null;
        }
        this.appService.updateIntervention(this.intervention).subscribe(interventions => {
          interventions.forEach(inter => {
            inter.date_inter = new DateJson(new Date(inter.date_inter.annee, inter.date_inter.mois, inter.date_inter.jour));
            if (inter.date_inter.mois === 0) {
              inter.date_inter.mois = 12;
              inter.date_inter.annee--;
            }
          });
          this.appService.listeInterventions=interventions;},
          (err: Response) => {
            console.log("Error occured");
        });
      }
      this.reInitAct();
      this.reInitActAFaire();
      this.reInitInterRuche();
      this.dateDatePicker = null;
      return true;
    }
    return false;
  }

  private reInitAct() {
    this.comActCourante = '';
    this.typeActCourante = new Nomenclature();
  }

  private reInitActAFaire() {
    this.comActAFaireCourante = '';
    this.typeActAFaireCourante = new Nomenclature();
  }

  private reInitInterRuche() {
    this.interRuche = '-1';
  }

  private verify() {
    if (!this.intervention.date_inter || this.intervention.type === '-1' || this.intervention.meteo === '-1') {
      this.isInterditBtn = true;
    } else {
      this.isInterditBtn = false;
    }
  }

  private testForm() {
    let testOK = true;
    let eltDp = document.getElementById("dp");
    if (this.intervention.date_inter) {
      eltDp.classList.remove("is-invalid");
    } else {
      if (!eltDp.classList.contains("is-invalid")) {
        eltDp.classList.add("is-invalid");
      }
      testOK = false;
    }

    if (this.intervention.type === '-1') {
      this.type_ok = false;
      testOK = false;
    } else {
      this.type_ok = true;
    }

    if (this.intervention.meteo === '-1') {
      this.meteo_ok = false;
      testOK = false;
    } else {
      this.meteo_ok = true;
    }
    
    let regex: RegExp = new RegExp("^-?[0-9]+");
    if (this.intervention.temperature && this.intervention.temperature.length !==0 && !regex.test(this.intervention.temperature)) {
      this.temperature_ok = false;
      testOK = false;
    } else {
      this.temperature_ok = true;
    }

    regex = new RegExp("[0-9]+");
    if (this.interRucheCourante && this.interRucheCourante.pds_kilos && this.interRucheCourante.pds_kilos.length !==0 && !regex.test(this.interRucheCourante.pds_kilos)) {
      this.kilos_ok = false;
      testOK = false;
    } else {
      this.kilos_ok = true;
    }

    if (this.interRucheCourante && this.interRucheCourante.pds_grammes && this.interRucheCourante.pds_grammes.length !==0 && !regex.test(this.interRucheCourante.pds_grammes)) {
      this.grammes_ok = false;
      testOK = false;
    } else {
      this.grammes_ok = true;
    }

    if (testOK) {
      this.isInterditBtn = false;
    } else {
      this.isInterditBtn = true;
    }

    return testOK;
  }
}



// WEBPACK FOOTER //
// ./src/app/principal/interventions/write-intervention-modal/write-intervention-modal.component.ts